//Labeeb CT
// const BASE_URL = "http://192.168.9.7:5000/node_api/";  

//Akhila
// const BASE_URL = "http://192.168.9.47:5010/node_api/"; 

//Live
const BASE_URL = "https://network.planxoffice.com/node_api/";  

//Demo 
// const BASE_URL = "http://162.19.146.134:1818/node_api/"; 

const DEFAULT_KEY = 'MXXIHAHDFHAODFHOAHSFOHF3428342AKSDFOHASIODFNFJKABSI'


const PAYPAL_CLIENT_ID = "ATtY3CotjXVye4iosAlVI4cuihnv8nNg_Y8R-dRLWPe_-GawRjLbtKqZxlSfP6XDOJlbvMR0I4ziL0a_"

export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID } 